var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单评论",
            visible: _vm.dialogVisible,
            width: "50%",
            rules: _vm.rules,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { size: "small", model: _vm.formData },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "评价", "label-width": _vm.labelWidth } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "textarea", rows: 2, maxlength: "200" },
                    model: {
                      value: _vm.formData.comment,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formData,
                          "comment",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formData.comment",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上传图片", "label-width": _vm.labelWidth } },
                [
                  _c("ImgUpload", {
                    attrs: { limit: 5 },
                    model: {
                      value: _vm.imageList,
                      callback: function ($$v) {
                        _vm.imageList = $$v
                      },
                      expression: "imageList",
                    },
                  }),
                  _c("div", [_vm._v("图片格式为jpg或png，图片大小不得超过5M")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitUpload()
                    },
                  },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }